<div class="container">
  <div class="selector">
    <h1>{{ 'choose-company' | translate }}</h1>
    <mat-form-field>
      <mat-label>{{ 'company' | translate }}</mat-label>
      <mat-select (selectionChange)="onSelectionChanged($event)"
                  [value]="companyRouteService.companyId">
        <ng-container *ngFor="let item of companyList">
          <mat-option [value]="item.id">{{ item.text }}</mat-option>
        </ng-container>
      </mat-select>
    </mat-form-field>
  </div>
</div>
